<template>
	<span>{{ localDateTime }}</span>
</template>

<script>
export default {
  mounted() {
  		this.convertToLocal();
  },
  props: [
            'datetime',
  ],
  data() {
    return {
		  localDateTime: this.datetime
    };
  },
  methods: {
    convertToLocal: function() {

    	var value = this.datetime;

      	if(value !== null){

              value = new Date( value.replace(/-/g, "/") + ' UTC');

              value = value.getDate() + '/' + (value.getMonth()+1) + '/' + value.getFullYear() + ' ' + value.getHours() + ':' + (value.getMinutes()<10?'0':'') + value.getMinutes();
        }

        this.localDateTime = value;

    }
   }
  }
</script>



	        